import { v4 as uuid } from 'uuid'
export const DEFAULT_THEMES_SERIALIZED = (project_id: string) => [
  {
    id: uuid(),
    project_id,
    name: 'light',
    mode: 'light',
    primary_main: '#009688',
    primary_light: 'rgb(51, 171, 159)',
    primary_dark: 'rgb(0, 105, 95)',
    primary_contrasttext: '#fff',
    secondary_main: '#f50057',
    secondary_light: 'rgb(247, 51, 120)',
    secondary_dark: 'rgb(171, 0, 60)',
    secondary_contrasttext: '#fff',
    error_main: '#d32f2f',
    error_light: '#ef5350',
    error_dark: '#c62828',
    error_contrasttext: '#fff',
    warning_main: '#ed6c02',
    warning_light: '#ff9800',
    warning_dark: '#e65100',
    warning_contrasttext: '#fff',
    info_main: '#0288d1',
    info_light: '#03a9f4',
    info_dark: '#01579b',
    info_contrasttext: '#fff',
    success_main: '#2e7d32',
    success_light: '#4caf50',
    success_dark: '#1b5e20',
    success_contrasttext: '#fff',
    text_primary: 'rgba(0, 0, 0, 0.87)',
    text_secondary: 'rgba(0, 0, 0, 0.6)',
    text_disabled: 'rgba(0, 0, 0, 0.38)',
    background_default: '#fff',
    background_paper: '#fff',
    action_active: 'rgba(0, 0, 0, 0.54)',
    action_hover: 'rgba(0, 0, 0, 0.04)',
    action_selected: 'rgba(0, 0, 0, 0.08)',
    action_disabled: 'rgba(0, 0, 0, 0.26)',
    action_disabled_background: 'rgba(0, 0, 0, 0.12)',
    action_focus: 'rgba(0, 0, 0, 0.12)',
  },
  {
    id: uuid(),
    project_id,
    name: 'dark',
    mode: 'dark',
    primary_main: '#009688',
    primary_light: 'rgb(51, 171, 159)',
    primary_dark: 'rgb(0, 105, 95)',
    primary_contrasttext: '#fff',
    secondary_main: '#f50057',
    secondary_light: 'rgb(247, 51, 120)',
    secondary_dark: 'rgb(171, 0, 60)',
    secondary_contrasttext: '#fff',
    error_main: '#f44336',
    error_light: '#e57373',
    error_dark: '#d32f2f',
    error_contrasttext: '#fff',
    warning_main: '#ffa726',
    warning_light: '#ffb74d',
    warning_dark: '#f57c00',
    warning_contrasttext: 'rgba(0, 0, 0, 0.87)',
    info_main: '#29b6f6',
    info_light: '#4fc3f7',
    info_dark: '#0288d1',
    info_contrasttext: 'rgba(0, 0, 0, 0.87)',
    success_main: '#66bb6a',
    success_light: '#81c784',
    success_dark: '#388e3c',
    success_contrasttext: 'rgba(0, 0, 0, 0.87)',
    text_primary: '#fff',
    text_secondary: 'rgba(255, 255, 255, 0.7)',
    text_disabled: 'rgba(255, 255, 255, 0.5)',
    background_default: '#333',
    background_paper: '#333',
    action_active: '#fff',
    action_hover: 'rgba(255, 255, 255, 0.08)',
    action_selected: 'rgba(255, 255, 255, 0.16)',
    action_disabled: 'rgba(255, 255, 255, 0.3)',
    action_disabled_background: 'rgba(255, 255, 255, 0.12)',
    action_focus: 'rgba(255, 255, 255, 0.12)',
  },
]
